/**
 * 有効期限から残り時間を計算するユーティリティ関数
 */

import type { PlainMessage, Timestamp } from "@bufbuild/protobuf";

/**
 * 有効期限から「分:秒」形式の残り時間を計算する
 * @param expiresAt 有効期限（Timestamp型または日付文字列）
 * @returns 残り時間を「分:秒」形式で表した文字列（例: "05:30"）
 */
export function calculateRemainingTime(
  expiresAt: PlainMessage<Timestamp>,
): string {
  if (!expiresAt) {
    return "00:00";
  }

  const now = new Date();
  let expireTime: Date;

  // Timestamp型の場合（seconds, nanosプロパティを持つ）
  if (
    typeof expiresAt === "object" &&
    expiresAt !== null &&
    "seconds" in expiresAt
  ) {
    const timestamp = expiresAt as PlainMessage<Timestamp>;
    const seconds = Number(timestamp.seconds);
    const nanos = timestamp.nanos || 0;
    expireTime = new Date(seconds * 1000 + nanos / 1000000);
  } else {
    // 文字列または他の形式の場合
    try {
      expireTime = new Date(expiresAt as string | number | Date);
    } catch (e) {
      return "00:00";
    }
  }

  const diff = expireTime.getTime() - now.getTime();

  if (diff <= 0) {
    return "00:00";
  }

  const minutes = Math.floor(diff / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}
